var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlassList(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.276 0a6.893 6.893 0 100 13.788 6.866 6.866 0 004.366-1.558l4.875 4.876.077.066a.686.686 0 00.894-1.037l-4.876-4.876A6.893 6.893 0 0016.276 0zm0 1.373a5.521 5.521 0 110 11.041 5.521 5.521 0 010-11.041z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.167 2.618a.833.833 0 01.123 1.657l-.123.01H.833A.833.833 0 01.71 2.626l.123-.01h5.334zM6.167 9.284a.833.833 0 01.123 1.658l-.123.009H.833A.833.833 0 01.71 9.293l.123-.009h5.334zM14.167 15.951a.833.833 0 01.123 1.658l-.123.009H.833A.833.833 0 01.71 15.96l.123-.009h13.334z"
  })));
}

export default SvgMagnifyingGlassList;